<template>
  <div
    v-if="id in $store.state.errors"
    class="form-error ion-margin-bottom"
    :id="id + '-error'"
  >{{ $store.state.errors[id] }}</div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.form-error {
  color: var(--ion-color-danger);
}
</style>
